module.exports = __webpack_public_path__ + "img/HA1508-76.24ea2154.jpg";